export default "__VITE_PUBLIC_ASSET__f53cc9f1__"